import { inject } from "@angular/core";
import { CanActivateFn, Router, UrlCreationOptions } from "@angular/router";
import { map } from "rxjs";
import { VirkeskopKontraktstyp } from "../virkeskop/models/kontrakt-models";
import { AvtalService } from "../virkeskop/services/avtal.service";

// eslint-disable-next-line sonarjs/function-return-type
export const kontraktstypGuard: CanActivateFn = (route, _state) => {
    const avtalService = inject(AvtalService);
    const router = inject(Router);

    const kontraktId: number = route.queryParams.kontraktId;

    if(!kontraktId) {
        return true;
    }

    const avtalId: number = route.params.id;
    const isSkogsvardFPV: boolean = route.data.isSkogsvardFPV;

    const options: UrlCreationOptions = {
        queryParams: route.queryParams
    };

    return avtalService.getKontrakt(kontraktId).pipe(
        // eslint-disable-next-line sonarjs/function-return-type
        map(k => {
            if(k.kontraktTyp === VirkeskopKontraktstyp.SkogsvardFPV && !isSkogsvardFPV) {
                // Om kontraktet är FPV men routen är virkesköp
                return router.createUrlTree([
                    "/skogsvardfpv/avtal",
                    avtalId
                ], options);
            } else if(k.kontraktTyp !== VirkeskopKontraktstyp.SkogsvardFPV && isSkogsvardFPV) {
                // Om kontraktet är virkesköp men route är FPV
                return router.createUrlTree([
                    "/virkeskop/avtal",
                    avtalId
                ], options);
            } else{
                // Om kontraktstyp och route stämmer fortsätt vidare
                return true;
            }
        })
    );
};
